import $ from 'jquery';
import {question} from '../api/api';
import setHeight from '../../scripts/util/dom/setHeight';
import resetClosestHeight from '../../scripts/util/dom/resetClosestHeight';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';

export default class Question {
	constructor() {
		this.selectors = {
			el: '.js-question',
			toggle: '.js-question-toggle',
			cross: '.js-question-close',
			wrapper: '.js-question-wrapper',
			message: '.js-question-message',
			messageText: '.js-message-text',
			content: '.js-question-content',
			status: '.js-question-status',
			toggleWrapper: '.js-toggle-wrapper',
			toggleContent: '.js-toggle-content'
		};

		this.classes = {
			open: 'question_state_open',
			success: 'question_state_success',
			message: 'message_state_visible'
		};

		this.$el = $(this.selectors.el);
		this.$toggle = $(this.selectors.toggle);
		this.$cross = $(this.selectors.cross);
		this.$wrapper = $(this.selectors.wrapper);
		this.$content = $(this.selectors.content);
		this.$message = $(this.selectors.message);

		this.$document = $(document);
		this.$window = $(window);
	}

	open = () => {
		this.$el.addClass(this.classes.open);
		setHeight(this.$wrapper, this.$content);
		resetClosestHeight(this.$el, this.selectors.toggleWrapper);
	}

	close() {
		this.$el.removeClass(this.classes.open);
		this.$wrapper.css('height', 0);
		resetClosestHeight(this.$el, this.selectors.toggleWrapper);
	}

	clearForm() {
		const form = document.querySelector(this.selectors.content);
		form.reset();
	}

	setStatusState(status) {
		const $status = this.$el.find(this.selectors.status);
		const $statusMob = this.$message.find(this.selectors.messageText);
		if (isViewport(lg)) {
			this.$message.addClass(this.classes.message);
			$statusMob.text(status);
			this.close();
			this.clearForm();
			setTimeout(() => this.$message.removeClass(this.classes.message), 6000);
		} else {
			this.$el.addClass(this.classes.success);
			$status.text(status);
		}
	}


	onResize = () => {
		const $el = $('.' + this.classes.open);
		if ($el.length) {
			setHeight(this.$wrapper, this.$content);
		}
	}

	onSubmit = e => {
		e.preventDefault();
		const $target = $(e.target);
		const $data = $target.serialize();
		question($data).then(
			data => this.setStatusState(data.message),
			data => this.setStatusState(data.message)
		);
	}

	render() {
		this.$cross.on('click', e => {
			e.stopPropagation();
			this.close();
		});
		this.$toggle.on('click', this.open);
		this.$window.on('resize', this.onResize);
		this.$content.on('submit', this.onSubmit);
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/question/question.js
 **/